import {
  getGetUserPerformanceTasksQueryKey,
  getGetTopPerformanceTasksQueryKey,
  likePerformanceTask,
  unlikePerformanceTask,
  useDeletePerformanceTask,
  useGetUserPerformanceTasks,
  useGetTopPerformanceTasks,
} from "@packages/api/madlenAPI";
import { PerformanceTaskCard } from "../../components/performance-task/PerformanceTaskCard";
import GenericToolPage from "../../components/tool_components/GenericToolPage";
import { PerformanceTaskResponseDto } from "@packages/api/madlenAPI.schemas";
import i18n from "@packages/i18n/config";

interface ExtendedPerformanceTaskResponseDto
  extends PerformanceTaskResponseDto {
  isEditable?: boolean;
}

const PerformanceTaskDetailComponent = ({
  tool,
}: {
  tool: ExtendedPerformanceTaskResponseDto;
}) => {
  return (
    <PerformanceTaskCard
      id={tool.id.toString()}
      authorName={tool.authorName ?? ""}
      performanceCriteria={tool.performanceCriteria || []}
      imageUrl={tool.imageUrl!}
      videoUrl={tool.videoUrl}
      courseName={tool.courseName!}
      gradeLevel={tool.gradeLevel!}
      prompt={tool.title || tool.prompt || ""}
      description={tool.description || ""}
      studentInstructions={tool.studentInstructions || ""}
      materialsNeeded={tool.materialsNeeded || []}
      isImageLoading={false}
      createdAt={tool.createdAt ?? ""}
      isEditable={tool.isEditable}
      contentLanguage={tool.contentLanguage || i18n.language}
    />
  );
};

const PerformanceTasksView = () => {
  return (
    <GenericToolPage
      useGetTools={useGetUserPerformanceTasks}
      useDeleteTool={useDeletePerformanceTask}
      getGetToolsQueryKey={getGetUserPerformanceTasksQueryKey}
      useGetTopTools={useGetTopPerformanceTasks}
      likeTool={likePerformanceTask}
      unlikeTool={unlikePerformanceTask}
      getGetTopToolsQueryKey={getGetTopPerformanceTasksQueryKey}
      toolType="performanceTasks"
      toolPath="performance-tasks"
      DetailComponent={PerformanceTaskDetailComponent}
      colors={{
        light: "from-blue-400 to-cyan-500",
        dark: "dark:from-blue-300 dark:to-cyan-400",
        iconBg: "bg-blue-100 dark:bg-cyan-900/50",
        iconColor: "text-cyan-600 dark:text-blue-300",
        hover: "hover:bg-blue-50 dark:hover:bg-cyan-900/20",
      }}
      toolColor="blue"
      gradientColor="rose"
    />
  );
};

export default PerformanceTasksView;
